import React, { useState, useEffect } from "react";
import { KeyboardAvoidingView, ScrollView, View } from "react-native";

import appStyles from "../../../appStyles";
import AppTheme from "../../AppTheme";
import BottomButton from "../../common/BottomButton";
import Utils, { escapeRegexp, hasItems } from "../../../../helpers/utils";
import ReportOverralComment from "./ReportOverralComment";
import Search from "../../common/search-bar/Search";
import EditReflectionGemsList from "../../reflection/edit/EditReflectionGemsList";
import cardStyles from "../../home/cards/cardStyles";

export default function ReportNotes({
  header,
  gems = [],
  timeUnit = "week",
  selectedJournalIds = [],
  updateOverallNotes,
  report,
  controller,
}) {
  const [gemsList, setGemsList] = useState([]);
  const [mainNotes, setMainNotes] = useState({});
  const [selectedGemIds, setSelectedGemIds] = useState(new Set());

  useEffect(() => {
    const gemIds = hasItems(selectedJournalIds)
      ? new Set(selectedJournalIds)
      : new Set(gems.map((g) => g.gem_id));

    gems.forEach((g) => {
      g.isSelected = gemIds.has(g.gem_id);
    });

    setGemsList(gems);
    setSelectedGemIds(gemIds);
  }, [gems.length]);

  toggleGemSelection = (gemId, isSelected) => {
    // All selector
    if (!gemId) {
      if (isSelected) {
        setSelectedGemIds(gemsList.map((g) => g.gem_id));
      } else {
        setSelectedGemIds(new Set());
      }
      return;
    }

    if (isSelected) {
      selectedGemIds.add(gemId);
    } else {
      selectedGemIds.delete(gemId);
    }

    setSelectedGemIds(selectedGemIds);
  };

  const saveNotes = (data) => {
    setMainNotes({ ...data });
  };

  filterResults = ({ term }) => {
    let filteredGems = [...gems];

    if (term) {
      const pattern = Utils.getSearchPattern(term);

      filteredGems = filteredGems.filter((g) => {
        return g.text && g.text.match(pattern);
      });
    }

    setGemsList(filteredGems);
  };

  const saveJournals = () => {
    updateOverallNotes({
      selectedGemIds: [...selectedGemIds],
      report: mainNotes,
    });
  };

  return (
    <View
      style={[appStyles.container, { backgroundColor: AppTheme.containerBg }]}
    >
      <KeyboardAvoidingView style={appStyles.kbViewNoFooter} behavior="height">
        {header}

        <View style={appStyles.preList} />

        <ScrollView
          style={appStyles.scrollView}
          contentContainerStyle={appStyles.scrollViewContent}
        >
          <ReportOverralComment saveNotes={saveNotes} report={report} />

          <View style={[cardStyles.card, { marginTop: 8, flex: 1 }]}>
            <EditReflectionGemsList
              gems={gemsList}
              timeUnit={timeUnit}
              toggleGemSelection={toggleGemSelection}
              inReportMode={true}
              controller={controller}
            />
          </View>
        </ScrollView>

        <View style={[appStyles.footerOptions]}>
          <Search
            showIcon={false}
            placeholder="Search Journals"
            filterResults={filterResults}
            style={{ marginBottom: 6, width: "96%", marginHorizontal: "2%" }}
            controller={controller}
          />

          <BottomButton
            buttonText="Preview Report"
            style={{ paddingHorizontal: 16, height: 40 }}
            onPress={saveJournals}
            disabled={!mainNotes.mood || !mainNotes.comment}
          />
        </View>
      </KeyboardAvoidingView>
    </View>
  );
}
